/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnGetChallenge
 */
export interface WebAuthnGetChallenge {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnGetChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnGetChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof WebAuthnGetChallenge
     */
    authentication_method: FactorMethod;
    /**
     * The "Options for Assertion Generation" as described by the WebAuthn spec at https://www.w3.org/TR/webauthn/#assertion-options
     * @type {object}
     * @memberof WebAuthnGetChallenge
     */
    options?: object;
}



/**
 * Check if a given object implements the WebAuthnGetChallenge interface.
 */
export function instanceOfWebAuthnGetChallenge(value: object): value is WebAuthnGetChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function WebAuthnGetChallengeFromJSON(json: any): WebAuthnGetChallenge {
    return WebAuthnGetChallengeFromJSONTyped(json, false);
}

export function WebAuthnGetChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnGetChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function WebAuthnGetChallengeToJSON(json: any): WebAuthnGetChallenge {
    return WebAuthnGetChallengeToJSONTyped(json, false);
}

export function WebAuthnGetChallengeToJSONTyped(value?: WebAuthnGetChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': value['options'],
    };
}

